import {BaseAnimation} from "./BaseAnimation";
import {Scene, Types} from "phaser";

export class Loading implements BaseAnimation
{

    private scene;
    private readonly IMAGES_NUMBER: number = 12;

    constructor (scene: Scene)
    {
        this.scene = scene;
    }

    generateFrames(): void
    {
        let frames: Array<Types.Animations.AnimationFrame> = new Array<Types.Animations.AnimationFrame>();

        for (let i = 1; i <= this.IMAGES_NUMBER; i++)
            frames.push({ key: 'loading' + i, frame: null});

        this.scene.anims.create({
            key: "loadingAnimation",
            frames: frames,
            frameRate: 6,
            repeat: -1
        });

    }



    loadImages(): void
    {
        for (let i = 1; i <= this.IMAGES_NUMBER; i++)
            this.scene.load.image("loading" + i, "assets/loading/" + i + ".png");

        this.scene.load.image("loadingText","assets/loading/testo.png");

    }

}
